<template>
  <div>
  <div class="spe-live" v-if="!json.init" :style="commonStyle" :ddt-area="`component_${json.floorId}_直播组件`" ddt-expose="on">
    <div class="live-list" :class="{'no-left-right-padding': jdata.commonStyle.margin}">
      <div class="live-list-wrap" :style="{'margin-right': (jdata.commonStyle.margin || 0) + 'px'}">
        <div
          class="live-item"
          v-for="(item,index) in jdata.liveList"
          :key="index"
          @click="toLink(item)"
          :style="{backgroundImage:`url(${item.img})`}"
          :ddt-src="item.id"
          :data-area="pt()"
          :data-pos="`component_${json.floorId}_直播组件.坑位${index + 1}_点击跳转`"
          :data-desc="item.id"
          :dd_name="`${pt()}.component_${json.floorId}_直播组件.坑位${index + 1}_点击跳转.${item.id}`"
          :ddt-click="`${pt()}.component_${json.floorId}_直播组件.坑位${index + 1}_点击跳转.${item.id}`"
          :ddt-pit="`坑位${index + 1}_点击跳转`"
          ddt-expose="on"
        >
          <div class="live-status-ing" v-if="item.status == 1">
            <div class="live-icon">
              <img src="//img61.ddimg.cn/upload_img/00848/h5/liveing-1623396353.gif" alt="">
            </div>
            <div class="live-txt">直播中</div>
          </div>
          <div class="live-status-end" v-if="item.status == 3">已结束</div>
          <div class="live-info">
            <div class="live-user"><span class="live-user-txt"><b class="live-user-ellipsis">主讲人：{{item.speaker}}</b></span></div>
            <div class="live-time">开播时间：{{item.playTime | time_filter}}</div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div v-else :style="{height:`${json.height}px`}"></div>
  </div>
</template>

<script>
import { formatDate } from  '../assets/js/format'

export default {
  name: "spe-live",
  props: {
    json: {
      type: Object,
      default: () => ({})
    }
  },
  data(){
    return{
    }
  },
  inject: ['pt'],
  computed: {
    jdata() {
      return this.json.data || { commonStyle: {}, headerStyle: {} ,header:{}, explainStyle:[],fontStyle:{},btnStyle:{},dashStyle:{}};
    },
    commonStyle() {
      let sty = {};
      if (this.jdata.commonStyle.backgroundType == 1) {
        if (this.jdata.commonStyle.usePageBackgroundColor) {
          sty.backgroundColor =this.jdata.commonStyle.bgColor
        }else{
          sty.backgroundColor = this.jdata.commonStyle.backgroundColor;
        }
      } else if(this.jdata.commonStyle.backgroundType == 2){
        //背景图
        sty.backgroundImage = `url(${this.jdata.commonStyle.backgroundImage})`;
      }
      sty.padding = `0 ${this.jdata.commonStyle.margin || 0}px`
      return sty;
    },
  },
  methods:{
    toLink(item){
      item.status != 3 ? this.$sys.dict.href(item.linkUrl):  this.$toast( '直播已结束')
    }
  },
  filters: {
    time_filter(v){
      return formatDate(v,"YYYY.MM.DD HH:mm")
    }
  }
}
</script>

<style scoped lang="less">
  .spe-live{
    width: 100%;
    box-sizing: border-box;
    background-repeat: no-repeat;
    background-position: left top;
    background-size: 100% 100%;
    overflow-x: auto;
    overflow-y: hidden;
    &::-webkit-scrollbar{width:0px;height:0px;}
    width: 100%;
    .live-list{
      /*padding-top: .3rem;*/
      width: max-content;
      display: flex;
      flex-direction: row;
      overflow-x: scroll;
      padding: .3rem .2rem 0;
      &::-webkit-scrollbar{width:0px;height:0px;}
      &.no-left-right-padding {
        padding-left: 0;
        padding-right: 0;
      }
      .live-list-wrap {
        display: flex;
        flex-wrap: nowrap;
      }

      .live-item{
        width: 3rem;
        height: 4.7rem;
        border-radius: .08rem;
        margin-right: .16rem;
        position: relative;
        overflow: hidden;
        background-size: 100% 100%;
        background-repeat: no-repeat;
        background-position: 0 0 ;
        &:last-child{
          margin-right: 0rem;
        }
        .live-status-end{
          width: .86rem;
          margin-top: .13rem;
          margin-left: .12rem;
          height: .32rem;
          display: flex;
          align-items: center;
          justify-content: center;
          background: rgba(0,0,0,0.70);
          border-radius: .2rem;
          font-size: .2rem;
          color: #FFFFFF;
          font-weight: 400;
          box-sizing: border-box;
        }
        .live-status-ing{
          width: 1.24rem;
          margin-top: .13rem;
          margin-left: .12rem;
          height: .32rem;
          display: flex;
          flex-direction: row;
          background: rgba(0,0,0,0.70);
          border-radius: .2rem;

          .live-icon{
            width: .44rem;
            height: .32rem;
            background-image: linear-gradient(160deg, #FF463C 0%, #FF3C78 100%);
            border-radius: .20rem;
            display: flex;
            align-items: center;
            justify-content: center;
            margin-right: .1rem;
            > img{
              width: .24rem;
              height: .24rem;
              display: block;
            }
          }
          .live-txt{
            /*width: 1.06rem;*/
            height: 100%;
            font-family: PingFangSC-Regular;
            font-size: .2rem;
            color: #FFFFFF;
            font-weight: 400;
            box-sizing: border-box;
            display: flex;
            align-items: center;
            justify-content: center;
          }
        }
        .live-info{
          width: 100%;
          height: 1.6rem;
          background-image: linear-gradient(180deg, rgba(0,0,0,0.00) 0%, rgba(0,0,0,0.50) 37%, rgba(0,0,0,0.70) 100%);
          position: absolute;
          bottom: 0;
          left: 0;
          .live-user{
            display: table;
            width: 100%;
            height: 1.01rem;
            font-size: .26rem;
            color: #FFFFFF;
            letter-spacing: 0;
            line-height: .32rem;
            font-weight: bold;
            padding:  0 .12rem;
            box-sizing: border-box;
            .live-user-txt {
              display: table-cell;
              vertical-align: bottom;
              .live-user-ellipsis {
                width: 100%;
                max-height: 0.62rem;
                overflow: hidden;
                text-overflow: ellipsis;
                word-break: break-all;
                display: -webkit-box;
                -webkit-box-orient: vertical;
                -webkit-line-clamp: 2;
                white-space: normal;
              }
            }
          }
          .live-time{
            width: 100%;
            height: .20rem;
            font-family: PingFangSC-Regular;
            font-size: .2rem;
            color: #DCDCDC;
            letter-spacing: 0;
            line-height: .2rem;
            font-weight: 400;
            padding:  0 .12rem;
            box-sizing: border-box;
            margin-top: .15rem;
          }
        }
      }
    }
  }
</style>
